export default [
  {
    _name: 'DashboardTiles',
    _children: [
      {
        _name: 'DashboardTile',
        name: 'Home',
        to: '/dashboard',
        fontIcon: 'fa fa-home',
      },
      {
        _name: 'DashboardTile',
        name: 'Orders',
        to: '/orders/list',
        fontIcon: 'fa fa-list',
      },
      {
        _name: 'DashboardTile',
        name: 'Estimates',
        to: '/estimates/list',
        fontIcon: 'fa fa-cubes',
      },
      {
        _name: 'DashboardTile',
        name: 'Library',
        to: '/documents/marketing',
        fontIcon: 'fa fa-ruler',
      }
    ]
  }
]
